import type { Database } from "@/integrations/supabase/types";

type IssueStatus = Database["public"]["Enums"]["issue_status_enum"] | "cancelled" | string;

/** Same Polish labels as Domio-Administracja `issueStatusLabelPl`. */
export function issueStatusLabelPl(status: IssueStatus | null | undefined): string {
  if (!status) return "—";
  const map: Record<string, string> = {
    new: "Nowe",
    open: "Otwarte",
    pending_admin_approval: "Oczekuje na akceptację",
    pending_cleaning_review: "W module sprzątania",
    in_progress: "W realizacji",
    waiting_for_parts: "Oczekiwanie na części",
    delegated: "Delegowane (B2B)",
    resolved: "Rozwiązane",
    rejected: "Odrzucone",
    cancelled: "Anulowane",
    ignored: "Odrzucone",
  };
  return map[status] ?? status;
}

export type CleaningIssueHistoryRow = {
  id: string;
  created_at: string | null;
  description: string | null;
  status: string | null;
  reporter_id: string | null;
  released_from_cleaning_at?: string | null;
  assigned_staff_id?: string | null;
  delegated_vendor_id?: string | null;
  claimed_by_org_id?: string | null;
  is_public_broadcast?: boolean | null;
  reporter?: { full_name: string | null } | null;
};

/** After handoff, before Admin forwards to Serwis / marketplace / B2B. */
export function canCleaningManagementSelfResolve(issue: CleaningIssueHistoryRow): boolean {
  const status = (issue.status ?? "").trim().toLowerCase();
  if (!["pending_admin_approval", "open", "new"].includes(status)) return false;
  if (!issue.released_from_cleaning_at) return false;
  if (issue.assigned_staff_id) return false;
  if (issue.delegated_vendor_id) return false;
  if (issue.claimed_by_org_id) return false;
  if (issue.is_public_broadcast === true) return false;
  return true;
}

export function issueStatusBadgeClass(status: string | null | undefined): string {
  switch ((status ?? "").toLowerCase()) {
    case "resolved":
      return "bg-green-500 hover:bg-green-500 text-white border-transparent";
    case "rejected":
    case "ignored":
    case "cancelled":
      return "bg-muted text-muted-foreground";
    case "pending_admin_approval":
    case "pending_cleaning_review":
      return "bg-amber-500/15 text-amber-800 dark:text-amber-200 border-amber-500/30";
    case "in_progress":
      return "bg-emerald-500/15 text-emerald-800 dark:text-emerald-200 border-emerald-500/30";
    default:
      return "";
  }
}
